{
  "common.back": "Back",
  "language.label": "Language",
  "navbar.internalUser": "Internal view",
  "navbar.reservationNumber": "Open {id}",
  "navbar.openReservationInErp": "Open booking {id} in the ERP",
  "navbar.locked": "Locked",
  "navbar.lockedInfo": "This reservation is locked ({status}) and can no longer be edited. You're viewing it as read-only.",
  "navbar.tripFallback": "Your trip",
  "navbar.stepShort": "Step {current}/{total}",
  "navbar.stepCrumb": "{current}/{total}",
  "navbar.step.1": "Build your trip",
  "navbar.step.2": "Traveller details",
  "navbar.step.3": "Summary",
  "navbar.step.4": "Payment",
  "navbar.login": "Sign in for benefits",
  "navbar.loginReplacesBooker.title": "Your account details become the booker",
  "navbar.loginReplacesBooker.body": "We'll take you to the passenger details, where you can check them before you continue.",
  "navbar.loginReplacesBooker.confirm": "Continue to sign in",
  "navbar.loginReplacesBooker.cancel": "Cancel",
  "navbar.account.open": "Your account",
  "navbar.account.fallbackName": "Your account",
  "navbar.account.bonus": "Holiday bonus available",
  "navbar.account.signOut": "Sign out",
  "landing.noTrip.title": "Pick a trip to continue",
  "landing.noTrip.body": "You haven't selected a trip to book yet. Browse our trips at imt.fi and come back to book your favourite.",
  "landing.noTrip.cta": "Browse trips",
  "landing.loading": "Loading your trip…",
  "landing.loadError.title": "Couldn't load your trip",
  "landing.loadError.body": "We couldn't open your trip. Check the link or try again in a moment.",
  "landing.loadError.retry": "Try again",
  "landing.loadError.back": "Browse trips at imt.fi",
  "pricing.title": "Price breakdown",
  "pricing.cancellation": "Cancellation cover · {label}",
  "pricing.newsletter": "Newsletter discount",
  "pricing.total": "Total",
  "pricing.totalPending": "-",
  "pricing.discountCode": "Discount code {code}",
  "pricing.paytrailDiscount": "Payment threshold discount",
  "pricing.giftCard": "Gift card",
  "pricing.rewardTrip": "Reward trip",
  "pricing.bonus": "Holiday bonus",
  "pricing.bonusGain": "You'll earn holiday bonus",
  "pricing.category.Hotel": "Accommodation",
  "pricing.category.Ship": "Ferry",
  "pricing.category.Cruise": "Cruise",
  "pricing.category.Flight": "Flight",
  "pricing.category.BusRouteGroup": "Transport",
  "pricing.category.DuringStayService": "Add-ons",
  "pricing.category.Extra": "Add-ons",
  "pricing.category.Other": "Other",
  "summary.open": "Summary",
  "summary.trip.title": "Trip details",
  "summary.trip.name": "Trip",
  "summary.trip.customName": "Your trip name",
  "summary.trip.dates": "Dates",
  "summary.trip.passengers": "Passengers",
  "summary.dates.night": "1 night",
  "summary.dates.nights": "{count} nights",
  "summary.trip.notSelected": "Not selected",
  "editor.appbar.back": "Back",
  "editor.entryError.noAvailability.title": "No trips available for this date",
  "editor.entryError.noAvailability.body": "Unfortunately there are no places left for this departure date. The trip is still bookable on other departure dates.",
  "editor.entryError.noAvailability.pickDate": "Choose another date",
  "editor.entryError.generic.title": "Couldn't open your trip",
  "editor.entryError.generic.body": "We couldn't open your trip. Check the link or try again in a moment.",
  "editor.entryError.generic.retry": "Try again",
  "editor.entryError.back": "Go back",
  "editor.basics.loading": "Updating your trip…",
  "editor.basics.editDates": "Change dates",
  "editor.basics.editPassengers": "Change travellers",
  "editor.basics.datesEmpty": "Pick dates",
  "editor.basics.datesViaTransport": "Chosen with your transfer",
  "editor.basics.passengersEmpty": "Pick travellers",
  "editor.basics.night": "1 night",
  "editor.basics.nights": "{count} nights",
  "editor.basics.dayTrip": "Day trip",
  "editor.basics.lead": "Start by picking your dates and travellers.",
  "editor.passengers.title": "Travellers",
  "editor.passengers.adults": "Adults",
  "editor.passengers.children": "Children",
  "editor.passengers.childrenHint": "under 18",
  "editor.passengers.adultsCount": "Number of adults",
  "editor.passengers.childrenCount": "Number of children",
  "editor.passengers.maxParty": "At most {count} passengers per booking.",
  "editor.passengers.maxPartyFlight": "Trips with flights take at most {count} passengers online. For larger groups we quote separately — contact ryhmat@imt.fi.",
  "editor.passengers.decreaseAdults": "Remove an adult",
  "editor.passengers.increaseAdults": "Add an adult",
  "editor.passengers.decreaseChildren": "Remove a child",
  "editor.passengers.increaseChildren": "Add a child",
  "editor.passengers.childAge": "Age of child {index}",
  "editor.passengers.childAgeHint": "The child's age on the trip's return date.",
  "editor.passengers.decreaseChildAge": "Lower the age of child {index}",
  "editor.passengers.increaseChildAge": "Raise the age of child {index}",
  "editor.passengers.done": "Done",
  "editor.passengers.close": "Close",
  "editor.ownCars.title": "Cars on the ferry",
  "editor.ownCars.lead": "Every car gets its own space on the car deck. Choose how many cars you bring and how big each one is, and we'll show the days they fit on.",
  "editor.ownCars.leadCountOnly": "Every car gets its own space on the car deck. Choose how many cars you bring, and we'll show the days they fit on.",
  "editor.ownCars.count": "Number of cars",
  "editor.ownCars.decrease": "Fewer cars",
  "editor.ownCars.increase": "More cars",
  "editor.ownCars.maxNote": "At most {count}: every car needs an adult driver.",
  "editor.ownCars.carOne": "Size of the car",
  "editor.ownCars.carN": "Car {index}",
  "editor.ownCars.type.CAR": "Car",
  "editor.ownCars.type.CAR.sub": "Up to 1.9 m high and 5 m long",
  "editor.ownCars.type.CAR XL": "High car",
  "editor.ownCars.type.CAR XL.sub": "Up to 2.4 m high and 5.5 m long",
  "editor.ownCars.type.VAN": "Van",
  "editor.ownCars.type.VAN.sub": "Up to 2.4 m high and 7 m long",
  "editor.ownCars.type.VAN HIGH": "High van or motorhome",
  "editor.ownCars.type.VAN HIGH.sub": "Up to 4.4 m high and 8 m long",
  "editor.ownCars.short.CAR": "car",
  "editor.ownCars.short.CAR XL": "high car",
  "editor.ownCars.short.VAN": "van",
  "editor.ownCars.short.VAN HIGH": "high van",
  "editor.ownCars.sizesNote": "The sizes are a guide and vary from ship to ship.",
  "editor.ownCars.help": "We'll ask for the registration numbers with the traveller details.",
  "editor.ownCars.done": "Continue",
  "editor.ownCars.close": "Close",
  "editor.dayPicker.title": "Pick your departure and return",
  "editor.dayPicker.titleDeparture": "Pick your departure day",
  "editor.dayPicker.titleReturn": "Pick your return day",
  "editor.dayPicker.titleFixed": "Confirm your trip",
  "editor.dayPicker.close": "Close",
  "editor.dayPicker.back": "Back to departure day",
  "editor.dayPicker.departureHeading": "Departure",
  "editor.dayPicker.returnHeading": "Return",
  "editor.dayPicker.departureOn": "Departure {date}",
  "editor.dayPicker.pickDepartureFirst": "Pick a departure day first",
  "editor.dayPicker.legendTitle": "Price estimate",
  "editor.dayPicker.tierCheap": "Cheaper",
  "editor.dayPicker.tierBase": "Standard",
  "editor.dayPicker.tierExpensive": "Pricier",
  "editor.dayPicker.tierUnknown": "Not known",
  "editor.dayPicker.night": "1 night",
  "editor.dayPicker.nights": "{count} nights",
  "editor.dayPicker.fromPerPerson": "From {amount} € / person",
  "editor.dayPicker.euroAmount": "{amount} €",
  "editor.dayPicker.capTotal": "total from",
  "editor.dayPicker.capPerPerson": "per person from",
  "editor.dayPicker.returnOn": "Return {date}",
  "editor.dayPicker.expandMore": "Show more options",
  "editor.dayPicker.expandLess": "Show fewer options",
  "editor.dayPicker.commit": "Choose these dates",
  "editor.dayPicker.commitFixed": "Confirm",
  "editor.dayPicker.feedbackPickDeparture": "Pick a departure day",
  "editor.dayPicker.feedbackPickReturn": "Pick how long you're staying",
  "editor.dayPicker.feedbackChosen": "Departure {departure}, return {return}, {duration}",
  "editor.dayPicker.feedbackUnavailable": "{date} isn't available. Please pick other dates.",
  "editor.dayPicker.feedbackUnavailableFixed": "{date} is full. This trip only runs on that day.",
  "editor.dayPicker.loading": "Loading prices…",
  "editor.dayPicker.error": "Couldn't load prices.",
  "editor.dayPicker.empty": "No departures this month.",
  "editor.dayPicker.showMoreMonths": "Show more months",
  "editor.dayPicker.loadingDurations": "Checking lengths and prices…",
  "editor.dayPicker.durationsError": "Couldn't load exact prices. Showing an estimate.",
  "editor.dayPicker.noBusForDay": "There is no coach from {city} on this day. Please pick another day.",
  "editor.dayPicker.noBusForFixedDay": "There is no coach from {city} on {date}. This trip only runs on that day, so please pick another departure city.",
  "editor.dayPicker.pickCityFirst": "Choose your departure city first to see the coach options.",
  "editor.dayPicker.pickCity": "Choose a city",
  "editor.dayPicker.changeCity": "{city} – change",
  "editor.dayPicker.busDirection.label": "Coach direction",
  "editor.dayPicker.busDirection.both": "Both ways",
  "editor.dayPicker.busDirection.outbound": "Outbound only",
  "editor.dayPicker.busDirection.return": "Return only",
  "editor.dayPicker.busLegendOutbound": "Green = the trip departs and the {city} outbound coach runs on this day",
  "editor.dayPicker.busLegendReturn": "Arrow = the {city} return coach runs on this day",
  "editor.dayPicker.busLegendOutboundPlain": "Green = the trip departs and the outbound coach runs on this day",
  "editor.dayPicker.busLegendReturnPlain": "Arrow = the return coach runs on this day",
  "editor.dayPicker.returnBusMark": "Return coach",
  "editor.dayPicker.busOutboundLeg": "{origin} (departs {time}) – {destination}",
  "editor.dayPicker.busReturnLeg": "{origin} – {destination} (returns {time})",
  "editor.dayPicker.busLegUntimed": "{origin} – {destination}",
  "editor.busCity.title": "Choose a city",
  "editor.busCity.lead": "The exact stop is chosen for each traveller separately when completing the booking.",
  "editor.busCity.close": "Close",
  "editor.busCity.searchPlaceholder": "Search for a city",
  "editor.busCity.popular": "Most popular",
  "editor.busCity.all": "All cities",
  "editor.busCity.results": "Search results",
  "editor.busCity.noResults": "No matches",
  "editor.busCity.loading": "Loading departure cities…",
  "editor.busCity.error": "Could not load departure cities.",
  "editor.busCity.noBus": "No coach",
  "editor.busCity.noBusSub": "Makes their own way to the port",
  "editor.busGroups.title": "Departure points",
  "editor.busGroups.lead": "Travellers can set off from different towns. Each departure point needs at least one adult.",
  "editor.busGroups.close": "Close",
  "editor.busGroups.groupTitle": "Departure point {index}",
  "editor.busGroups.remove": "Remove",
  "editor.busGroups.change": "Change",
  "editor.busGroups.add": "Add travellers from another departure point",
  "editor.busGroups.coachOk": "The coach runs on your dates",
  "editor.busGroups.coachBad": "No coach on your dates",
  "editor.busGroups.blocked": "There is no coach from every departure point on your dates. Change the departure point or your dates.",
  "editor.calendar.weekday.1": "MON",
  "editor.calendar.weekday.2": "TUE",
  "editor.calendar.weekday.3": "WED",
  "editor.calendar.weekday.4": "THU",
  "editor.calendar.weekday.5": "FRI",
  "editor.calendar.weekday.6": "SAT",
  "editor.calendar.weekday.7": "SUN",
  "editor.calendar.month.1": "January",
  "editor.calendar.month.2": "February",
  "editor.calendar.month.3": "March",
  "editor.calendar.month.4": "April",
  "editor.calendar.month.5": "May",
  "editor.calendar.month.6": "June",
  "editor.calendar.month.7": "July",
  "editor.calendar.month.8": "August",
  "editor.calendar.month.9": "September",
  "editor.calendar.month.10": "October",
  "editor.calendar.month.11": "November",
  "editor.calendar.month.12": "December",
  "editor.steps.dates.title": "Travel dates",
  "editor.steps.dates.prompt": "Choose your travel dates",
  "editor.steps.dates.sub": "Pick your outbound and return day",
  "editor.steps.dates.subLockedParty": "Opens once the travellers are chosen",
  "editor.steps.transport.title": "Transfer to harbour",
  "editor.steps.transport.bus.title": "Domestic bus transfer",
  "editor.steps.transport.self.title": "I'll get to the harbour myself",
  "editor.steps.transport.self.sub": "Own car or public transport",
  "editor.steps.transport.car.title": "My car on board",
  "editor.steps.transport.car.sub": "Reserve a car space on the ferry",
  "editor.steps.transport.hubTitle": "How will you get to the port?",
  "editor.steps.transport.hubSub": "Choose how you'll travel to the port",
  "editor.steps.transport.hubSubBeforeDates": "Choose how you'll travel, and you'll see the days that suit it",
  "editor.steps.transport.hubSummaryBus": "Coach transfer to the port",
  "editor.steps.transport.hubSummaryBusWithCity": "Coach transfer to the port, pick-up in {city}",
  "editor.steps.transport.hubSummaryBusOut": "Coach: {city}–port at {time}",
  "editor.steps.transport.hubSummaryBusIn": "Coach: port–{city} at {time}",
  "editor.steps.transport.hubSummaryBusOutUntimed": "Coach: {city}–port",
  "editor.steps.transport.hubSummaryBusInUntimed": "Coach: port–{city}",
  "editor.steps.transport.hubSummaryBusOutOnly": "Coach to the port only, pick-up in {city}",
  "editor.steps.transport.hubSummaryBusReturnOnly": "Coach from the port only, drop-off in {city}",
  "editor.steps.transport.hubSummaryNoReturnBus": "Own way home from the port",
  "editor.steps.transport.hubSummaryNoOutboundBus": "Own way to the port",
  "editor.steps.transport.hubSummaryCar": "Own car on board",
  "editor.steps.transport.hubSummaryCarOfType": "Own car on board · {type}",
  "editor.steps.transport.hubSummaryCars": "{count} cars on board · {types}",
  "editor.steps.transport.hubSummarySelf": "I'll get to the port myself",
  "editor.steps.transport.avail.ok": "Your dates work",
  "editor.steps.transport.avail.bad": "Pick another day",
  "editor.steps.transport.avail.checking": "Checking availability…",
  "editor.steps.transport.avail.pickCity": "Pick a city",
  "editor.steps.transport.avail.busCity": "Pick-up in {city}",
  "editor.steps.transport.avail.busOk": "{city} · your dates work",
  "editor.steps.transport.avail.busBad": "{city} · pick another day",
  "editor.steps.transport.busGroups.add": "Add travellers from another departure point",
  "editor.steps.transport.busGroups.edit": "Edit departure points",
  "editor.steps.transport.hubSummaryBusGroup": "Coach: {city} · {party}",
  "editor.steps.transport.hubSummarySelfGroup": "Own way to the port · {party}",
  "editor.hotelChangeReset.title": "Change hotel?",
  "editor.hotelChangeReset.body": "The extra services booked at your current hotel will be removed. Everything else — your ferries, cabins and other extras — stays as it is.",
  "editor.hotelChangeReset.confirm": "Change hotel",
  "editor.hotelChangeReset.cancel": "Keep current",
  "editor.ferryChangeReset.title": "Change ferry?",
  "editor.ferryChangeReset.body": "The extra services booked for this crossing will be removed. The rest of your trip is kept if it still fits the new departure; otherwise it is reselected.",
  "editor.ferryChangeReset.confirm": "Change ferry",
  "editor.ferryChangeReset.cancel": "Keep current",
  "editor.tripNotices.title": "Good to know about this trip",
  "editor.tripNotices.expand": "Show more",
  "editor.tripNotices.collapse": "Show less",
  "editor.steps.edit": "Edit",
  "editor.steps.select": "Choose",
  "editor.steps.view": "View",
  "editor.steps.collapse": "Done",
  "editor.steps.saveError": "We couldn't confirm your choice was saved. Check your selection and try again if needed.",
  "editor.steps.lockedBasics": "Opens once the dates and transfer are set",
  "editor.steps.lockedDates": "Opens once the dates are chosen",
  "editor.steps.lockedPrev": "Opens once {step} is chosen",
  "editor.steps.lockedOptional": "Opens once the previous choices are made",
  "editor.steps.next": "Choose this next",
  "editor.steps.optional": "Optional — choose or skip",
  "editor.steps.loadError": "We couldn't load the options for this step.",
  "editor.steps.loadErrorRetry": "Try again",
  "editor.steps.hotel.title": "Hotel",
  "editor.steps.hotel.titleInCity": "Hotel · {city}",
  "editor.steps.ferryOut.title": "Outbound ferry",
  "editor.steps.ferryOut.summaryTitle": "Outbound · {time}",
  "editor.steps.ferryIn.title": "Return ferry",
  "editor.steps.ferryIn.summaryTitle": "Return · {time}",
  "editor.steps.shipExtra.title": "Additional ferry",
  "editor.steps.shipExtra.summaryTitle": "Ferry · {time}",
  "editor.steps.cruise.title": "Cruise",
  "editor.steps.cruise.summaryTitle": "Cruise · {time}",
  "editor.steps.flight.title": "Flight",
  "editor.steps.flight.repick": "We couldn't book your flight. Please choose a flight again.",
  "editor.steps.flight.outboundShort": "Outbound {time}",
  "editor.steps.flight.inboundShort": "Return {time}",
  "editor.steps.flight.legShort": "Flight {time}",
  "editor.steps.flight.titleWithAirline": "Flights: {airline}",
  "editor.steps.flight.legRange": "{from} – {to} ({duration})",
  "editor.steps.flight.legRangeNoDuration": "{from} – {to}",
  "editor.steps.flight.legMoment": "{date} at {time}",
  "flightSheet.title": "Choose a flight",
  "flightSheet.results": "{count} flights",
  "flightSheet.resultsOne": "1 flight",
  "flightSheet.close": "Close",
  "flightSheet.card.srRoute": "{from} – {to} at {time}",
  "flightSheet.select": "Select",
  "flightSheet.selected": "Selected",
  "flightSheet.loading": "Searching for flights…",
  "flightSheet.baggage.title": "Baggage included in the price",
  "flightSheet.baggage.carryOn": "Cabin bag in the overhead bin / person",
  "flightSheet.baggage.lightBag": "Only a small under-seat bag / person",
  "flightSheet.baggage.checkedOne": "1 checked bag / person",
  "flightSheet.baggage.checked": "{count} checked bags / person",
  "flightSheet.baggage.checkedNone": "No checked bag included",
  "flightSheet.baggage.noteLink": "See details",
  "flightSheet.baggage.outbound": "Outbound",
  "flightSheet.baggage.return": "Return",
  "flightSheet.baggage.leg": "Flight {number}",
  "flightSheet.bagQuestion.title": "Do you need a checked bag?",
  "flightSheet.bagQuestion.yes": "Yes, I'm bringing a suitcase",
  "flightSheet.bagQuestion.yesHint": "We'll show flights that include a checked bag",
  "flightSheet.bagQuestion.no": "No, I'm travelling light",
  "flightSheet.bagQuestion.noHint": "Depending on the flight, you can bring a small bag or a cabin bag.",
  "flightSheet.bagToggle": "Checked bag",
  "flightSheet.bagQuestion.listHint": "We will show the matching flights once you have answered.",
  "flightSheet.bagQuestion.removed": "The flight you chose doesn't include a checked bag. Please choose a new flight.",
  "flightSheet.sort.label": "Sort",
  "flightSheet.sort.recommended": "Recommended",
  "flightSheet.sort.cheapest": "Cheapest",
  "flightSheet.sort.fastest": "Fastest",
  "flightSheet.filter.button": "Filter",
  "flightSheet.filter.title": "Filter flights",
  "flightSheet.filter.stopovers": "Stops",
  "flightSheet.filter.stopover.none": "Direct",
  "flightSheet.filter.stopover.one": "Up to 1 stop",
  "flightSheet.filter.stopover.all": "All",
  "flightSheet.filter.airlines": "Airlines",
  "flightSheet.filter.flightDuration": "Flight duration",
  "flightSheet.filter.departureTime": "Departure time",
  "flightSheet.filter.returnTime": "Return time",
  "flightSheet.filter.reset": "Reset",
  "flightSheet.filter.apply": "Apply",
  "flightSheet.tag.recommended": "Recommended",
  "flightSheet.tag.cheapest": "Cheapest",
  "flightSheet.tag.fastest": "Fastest",
  "flightSheet.source.allotment": "Allotment",
  "flightSheet.stopover.none": "direct",
  "flightSheet.stopover.one": "1 stop",
  "flightSheet.stopover.many": "{count} stops",
  "flightSheet.duration.hoursMinutes": "{hours} h {minutes} min",
  "flightSheet.duration.hours": "{hours} h",
  "flightSheet.duration.minutes": "{minutes} min",
  "flightSheet.details.layover": "Connection in {airport} · {duration}",
  "flightSheet.details.terminal": "T{terminal}",
  "flightSheet.showDetails": "Flight details",
  "flightSheet.hideDetails": "Hide details",
  "flightSheet.price.included": "No extra charge",
  "flightSheet.price.extra": "+{amount} € / person",
  "flightSheet.price.cheaper": "Save {amount} € / person",
  "flightSheet.baggageNote.finnair": "On Finnair flights carry-on bags must fit under the seat in front of you.",
  "flightSheet.baggageNote.norwegian": "On Norwegian flights carry-on bags must fit under the seat in front of you.",
  "flightSheet.noAvailability.title": "No flights available for your dates",
  "flightSheet.noAvailability.body": "Try choosing different dates and we'll search again.",
  "flightSheet.noAvailability.close": "Close",
  "flightSheet.empty": "No flights matched your search.",
  "flightSheet.error": "Loading flights failed. Please try again.",
  "flightSheet.retry": "Try again",
  "flightSheet.filtered.empty": "No flights match the current filters.",
  "flightSheet.filtered.emptyOthers": "No other flights match the current filters.",
  "flightSheet.filtered.clear": "Clear filters",
  "editor.steps.cancel.title": "Cancellation cover",
  "editor.steps.upsells.title": "Add-ons",
  "editor.steps.upsells.loading": "Updating add-ons…",
  "editor.steps.upsells.summaryTitleSelected": "{count} add-ons selected",
  "editor.steps.upsells.summaryTitleSelectedOne": "1 add-on selected",
  "editor.steps.upsells.summaryLineSelected": "Hotel, ferry and on-trip extras",
  "editor.steps.upsells.sheetTitle": "Add to your trip",
  "editor.steps.upsells.sheetClose": "Close",
  "editor.steps.upsells.empty": "No add-ons are available for this trip.",
  "editor.steps.upsells.toggleError": "Couldn't update the add-on — it may no longer be available. Please review your selection.",
  "editor.steps.upsells.save": "Done",
  "editor.steps.upsells.selectedNone": "No add-ons selected",
  "editor.steps.upsells.includedSuffix": "/pax",
  "editor.steps.upsells.perReservationSuffix": "/booking",
  "editor.steps.upsells.groupShipOutbound": "Outbound ferry",
  "editor.steps.upsells.groupShipInbound": "Return ferry",
  "editor.steps.upsells.groupHotel": "At the hotel",
  "editor.steps.upsells.groupBus": "Bus connection",
  "editor.steps.upsells.groupDuringStay": "On site",
  "editor.steps.upsells.groupCity": "On site",
  "editor.steps.upsells.groupOther": "Other",
  "editor.steps.tickets.title": "Tickets",
  "editor.steps.tickets.loading": "Updating tickets…",
  "editor.steps.tickets.summaryTitleSelected": "{count} tickets selected",
  "editor.steps.tickets.summaryTitleSelectedOne": "1 ticket selected",
  "editor.steps.tickets.summaryLineSelected": "Tickets for events and attractions on your trip",
  "editor.steps.tickets.sheetTitle": "Choose your tickets",
  "editor.steps.tickets.sheetClose": "Close",
  "editor.steps.tickets.empty": "No tickets are available for this trip.",
  "editor.steps.tickets.toggleError": "Couldn't update the ticket — it may no longer be available. Please review your selection.",
  "editor.steps.tickets.save": "Done",
  "editor.steps.tickets.selectedNone": "No tickets selected",
  "editor.steps.tickets.count": "{count} tickets",
  "editor.steps.tickets.countOne": "1 ticket",
  "editor.trust.title": "imt.fi - Ikaalisten Matkatoimisto",
  "editor.trust.tagline": "Serving travellers since 1991",
  "editor.trust.legal": "Travel package act protection",
  "editor.trust.finnish": "Finnish",
  "editor.trust.rating": "4.6 / 5 Google rating",
  "editor.trust.travellers": "1,000,000+ travellers",
  "editor.cta.book": "Continue to passenger details",
  "editor.cta.bookShort": "Continue",
  "editor.cta.viewPassengers": "View passenger details",
  "editor.cta.viewPassengersShort": "Passengers",
  "editor.cta.hintBasics": "Pick your dates and travellers first",
  "editor.cta.hintSteps": "A few trip choices still to make",
  "editor.cta.hintNext": "Choose {step} next",
  "editor.sticky.dateFallback": "Pick dates",
  "hotelSheet.title": "Choose a hotel",
  "hotelSheet.detailTitleOne": "Choose a room",
  "hotelSheet.detailTitle": "Choose rooms",
  "hotelSheet.close": "Close",
  "hotelSheet.back": "Back to list",
  "hotelSheet.results": "{count} hotels in {city}",
  "hotelSheet.resultsOne": "1 hotel in {city}",
  "hotelSheet.resultsPlain": "{count} hotels",
  "hotelSheet.resultsPlainOne": "1 hotel",
  "hotelSheet.loading": "Searching for hotels…",
  "hotelSheet.sort.label": "Sort",
  "hotelSheet.sort.value": "Sort: {value}",
  "hotelSheet.sort.priceAsc": "Cheapest first",
  "hotelSheet.sort.priceDesc": "Most expensive first",
  "hotelSheet.sort.rating": "Best rated",
  "hotelSheet.sort.distance": "Closest to centre",
  "hotelSheet.filter.open": "Filter",
  "hotelSheet.filter.stars": "Star rating",
  "hotelSheet.filter.starsOption": "{count} stars",
  "hotelSheet.filter.starsValue": "{value} stars",
  "hotelSheet.filter.location": "Location",
  "hotelSheet.filter.score": "Score",
  "hotelSheet.filter.scoreOption": "Score {min}+",
  "hotelSheet.filter.scoreValue": "{min}+",
  "hotelSheet.filter.clear": "Clear",
  "hotelSheet.filter.showResults": "Show {count} hotels",
  "hotelSheet.filter.showResultsOne": "Show 1 hotel",
  "hotelSheet.filter.distance.near": "Under 1 km from centre",
  "hotelSheet.filter.distance.mid": "1–3 km from centre",
  "hotelSheet.filter.distance.far": "Over 3 km from centre",
  "hotelSheet.empty.title": "No hotels match these filters",
  "hotelSheet.empty.body": "Try relaxing the filters to see more options.",
  "hotelSheet.empty.clear": "Clear filters",
  "hotelSheet.card.select": "See rooms",
  "hotelSheet.card.selected": "Chosen",
  "hotelSheet.card.saleShort": "Sale",
  "hotelSheet.card.notices": "Please note",
  "hotelSheet.card.noticesAria": "Please note: {hotel}. Open the hotel details.",
  "hotelSheet.detail.notices": "Please note",
  "hotelSheet.price.included": "No extra charge",
  "hotelSheet.price.extra": "+{amount} € / person",
  "hotelSheet.price.cheaper": "Save {amount} € / person",
  "hotelSheet.price.includedDiscount": "Includes {amount} € / person off",
  "hotelSheet.rating.excellent": "Excellent",
  "hotelSheet.rating.veryGood": "Very good",
  "hotelSheet.rating.good": "Good",
  "hotelSheet.rating.reviews": "{count} reviews",
  "hotelSheet.rating.reviewsOne": "1 review",
  "hotelSheet.rating.reviewsShort": "({count})",
  "hotelSheet.rating.stars": "{count}-star hotel",
  "hotelSheet.map.show": "Show map",
  "hotelSheet.map.showList": "Show list",
  "hotelSheet.map.hint": "You can pan and zoom the map.",
  "hotelSheet.map.unavailable": "The map cannot be shown right now.",
  "hotelSheet.map.loading": "Finding hotel locations…",
  "hotelSheet.map.noLocations": "No map location was found for these hotels.",
  "hotelSheet.map.closeCard": "Close hotel card",
  "hotelSheet.map.noExtra": "No extra cost",
  "hotelSheet.map.label": "Map of hotels",
  "hotelSheet.detail.showOnMap": "Show on map",
  "hotelSheet.detail.customerRating": "imt.fi customer score",
  "hotelSheet.detail.allPhotos": "All {count} photos",
  "hotelSheet.detail.photoCount": "{index}/{total}",
  "hotelSheet.detail.prevPhoto": "Previous photo",
  "hotelSheet.detail.nextPhoto": "Next photo",
  "hotelSheet.detail.amenities": "Hotel amenities",
  "hotelSheet.detail.why": "Why choose {name}?",
  "hotelSheet.detail.exploreArea": "Explore the area",
  "hotelSheet.detail.reviewsTitle": "imt.fi customer reviews",
  "hotelSheet.detail.ratingOutOf": "{score} / 10",
  "hotelSheet.detail.discountedRooms": "Discounted room rates",
  "hotelSheet.detail.checkIn": "Check-in",
  "hotelSheet.detail.checkOut": "Check-out",
  "hotelSheet.detail.reception": "Reception",
  "hotelSheet.detail.gallery": "Hotel photos",
  "hotelSheet.detail.aboutTitle": "About the hotel",
  "hotelSheet.board.breakfast": "Breakfast included",
  "hotelSheet.board.halfBoard": "Half board",
  "hotelSheet.board.fullBoard": "Full board",
  "hotelSheet.board.allInclusive": "All inclusive",
  "hotelSheet.rooms.section": "Room {index} · {people}",
  "hotelSheet.count.roomsOne": "1 room",
  "hotelSheet.count.rooms": "{count} rooms",
  "party.adultsOne": "1 adult",
  "party.adults": "{count} adults",
  "party.childrenOne": "1 child",
  "party.children": "{count} children",
  "party.adultsAndChildren": "{adults}, {children}",
  "hotelSheet.rooms.loading": "Loading rooms…",
  "hotelSheet.rooms.none": "No rooms available.",
  "hotelSheet.rooms.error": "Loading rooms failed.",
  "hotelSheet.rooms.retry": "Try again",
  "hotelSheet.rooms.amenities": "Room amenities",
  "hotelSheet.perk.airConditioning": "Air conditioning",
  "hotelSheet.perk.beach": "Close to the beach",
  "hotelSheet.perk.breakfast": "Breakfast included",
  "hotelSheet.perk.halfBoard": "Half board included",
  "hotelSheet.perk.fullBoard": "Full board included",
  "hotelSheet.perk.allInclusive": "All inclusive",
  "hotelSheet.perk.city": "In the city centre",
  "hotelSheet.perk.location": "Location",
  "hotelSheet.perk.sustainability": "Sustainable choice",
  "hotelSheet.perk.bar": "Bar",
  "hotelSheet.perk.bike": "Bicycles available",
  "hotelSheet.perk.pool": "Swimming pool",
  "hotelSheet.perk.elevator": "Lift",
  "hotelSheet.perk.family": "Family-friendly",
  "hotelSheet.perk.gym": "Gym",
  "hotelSheet.perk.accessible": "Accessible",
  "hotelSheet.perk.kids": "Children's play area",
  "hotelSheet.perk.maleFemale": "Separate men's and women's facilities",
  "hotelSheet.perk.parking": "Parking",
  "hotelSheet.perk.pets": "Pets allowed",
  "hotelSheet.perk.restaurant": "Restaurant",
  "hotelSheet.perk.sauna": "Sauna",
  "hotelSheet.perk.sports": "Sports facilities",
  "hotelSheet.perk.swimming": "Lap swimming",
  "hotelSheet.perk.wifi": "Free WiFi",
  "hotelSheet.perk.tub": "Bathtub",
  "hotelSheet.perk.shower": "Shower",
  "hotelSheet.perk.balcony": "Balcony",
  "hotelSheet.perk.frenchBalcony": "French balcony",
  "hotelSheet.perk.minibar": "Minibar / fridge",
  "hotelSheet.perk.allergyRoom": "Allergy-friendly room",
  "hotelSheet.perk.safe": "Safe",
  "hotelSheet.perk.coffeeMachine": "Coffee maker",
  "hotelSheet.perk.kettle": "Kettle",
  "hotelSheet.perk.iron": "Iron",
  "hotelSheet.perk.smoking": "Smoking room",
  "hotelSheet.perk.roomService": "24h room service",
  "hotelSheet.perk.robe": "Bathrobe",
  "hotelSheet.perk.slippers": "Slippers",
  "hotelSheet.perk.desk": "Desk",
  "hotelSheet.perk.hairdryer": "Hairdryer",
  "hotelSheet.perk.bidet": "Bidet shower",
  "hotelSheet.perk.bathProducts": "Complimentary toiletries",
  "hotelSheet.rooms.scarcity": "Only {count} left!",
  "hotelSheet.rooms.takenByOtherRooms": "Already picked for your other rooms",
  "hotelSheet.rooms.fallbackName": "Room {index}",
  "hotelSheet.rooms.showMore": "Show more",
  "hotelSheet.rooms.showLess": "Show less",
  "hotelSheet.rooms.details": "Room details",
  "hotelSheet.rooms.hideDetails": "Hide details",
  "hotelSheet.rooms.select": "Choose",
  "hotelSheet.rooms.included": "No extra charge",
  "hotelSheet.rooms.deal": "DEAL",
  "hotelSheet.rooms.soldOut": "Sold out",
  "hotelSheet.split.title": "Room split",
  "hotelSheet.split.edit": "Change room split",
  "hotelSheet.split.done": "Done",
  "hotelSheet.split.howMany": "How many rooms do you need?",
  "hotelSheet.split.allInOne": "Everyone in one room",
  "hotelSheet.split.rooms": "{count} rooms",
  "hotelSheet.split.room": "Room {index}",
  "hotelSheet.split.moveTo": "Move to room {index}",
  "hotelSheet.split.moveNew": "Move to a new room",
  "hotelSheet.split.cancel": "Cancel",
  "hotelSheet.split.warnMax": "At most {count} people per room",
  "hotelSheet.split.warnChildAlone": "A child cannot stay in a room alone",
  "hotelSheet.split.warnEmpty": "A room must have at least one traveller",
  "hotelSheet.split.note": "Changing the room split affects the package price. Choose a room type for each room below.",
  "hotelSheet.split.passenger": "Passenger {index}",
  "hotelSheet.split.child": "Child, age {age}",
  "hotelSheet.split.childNoAge": "Child",
  "hotelSheet.split.moveLabel": "Move {name}",
  "hotelSheet.split.summary": "{rooms} · {people}",
  "hotelSheet.footer.total": "Package total",
  "hotelSheet.footer.noRoom": "No room chosen",
  "hotelSheet.footer.roomsChosen": "{chosen}/{total} rooms chosen",
  "hotelSheet.footer.allChosen": "{count} rooms chosen",
  "hotelSheet.footer.confirmOne": "Confirm room",
  "hotelSheet.footer.confirm": "Confirm rooms",
  "cancel.Basic.title": "Basic",
  "cancel.Basic.sub": "Free cancellation up to 7 days before departure",
  "cancel.Basic.deadline": "7 days before departure",
  "cancel.Change.title": "Flexible",
  "cancel.Change.sub": "Free cancellation up to 2 days before departure",
  "cancel.Change.deadline": "2 days before departure",
  "cancel.Cancellation.title": "Maximum",
  "cancel.Cancellation.sub": "Free cancellation up to 2 h before departure",
  "cancel.Cancellation.deadline": "2 hours before departure",
  "cancel.freeCancel": "Free cancellation in the app up to",
  "cancel.terms": "Cancellation must be made in the IMT Oma Loma app. Refund as holiday bonus, valid for one year.",
  "cancel.priceFree": "Included",
  "cancel.pricePerPax": "+{amount} €/pax",
  "cancel.recommended": "Recommended",
  "cancel.general.title": "Cover included in every trip",
  "cancel.general.intro": "Change of plans? No worries – IMT.fi's exceptional cancellation cover gives you peace of mind for this trip. On top of that, every IMT.fi trip includes general change cover, described below and in the travel terms and special terms.",
  "cancel.general.advisory": "Free cancellation if the Ministry for Foreign Affairs advises against travel",
  "cancel.general.hotline": "Finnish-speaking 24/7 emergency line while you travel",
  "cancel.general.freeCancel": "Free cancellation within 24 hours of booking, if departure is at least 7 days away",
  "cancel.general.change": "Changes for an office fee up to 21 days before departure",
  "cancel.general.termsLink": "General package travel terms",
  "cancel.general.specialTermsLink": "Additional and special terms",
  "cancel.sheetTitle": "Cancellation cover",
  "cancel.sheetClose": "Close",
  "passengerInfo.appbar.back": "Back",
  "passengerInfo.appbar.tripFallback": "Your trip",
  "passengerInfo.appbar.title": "Your details and travel companions",
  "passengerInfo.section.booker": "Trip booker",
  "passengerInfo.section.passenger": "Passenger {index}",
  "passengerInfo.section.clearPassenger": "Clear all",
  "passengerInfo.bookerIsGuest": "I'm one of the passengers",
  "passengerInfo.card.bookerAsPassenger": "Passenger 1 · booker",
  "passengerInfo.card.bookerTag": "Booker",
  "passengerInfo.card.empty": "Not filled in yet",
  "passengerInfo.card.filled": "filled in",
  "passengerInfo.card.invalid": "Check the details you entered",
  "passengerInfo.card.missing": "{count} fields missing",
  "passengerInfo.card.missingOne": "1 field missing",
  "passengerInfo.card.fill": "Fill in",
  "passengerInfo.card.edit": "Change",
  "passengerInfo.card.collapse": "Done",
  "passengerInfo.card.aria": "{role}, {status}",
  "passengerInfo.card.ariaNamed": "{role}, {name}, {status}",
  "passengerInfo.missing.title": "Still to fill in",
  "passengerInfo.login.ariaLabel": "Sign in",
  "passengerInfo.login.title": "Sign in to see your trip in the IMT Oma Loma app",
  "passengerInfo.login.perkApp": "All your details in one place",
  "passengerInfo.login.perkBonus": "€{amount} holiday bonus",
  "passengerInfo.login.perkChat": "Chat customer service",
  "passengerInfo.login.signIn": "Sign in",
  "passengerInfo.login.join": "Join for free",
  "passengerInfo.login.guestNote": "You can also book without an account.",
  "passengerInfo.login.signedInTitle": "Hi {name}. We have prefilled your details – please check them.",
  "passengerInfo.login.signedInTitleNoName": "Hi! We have prefilled your details – please check them.",
  "passengerInfo.login.signedInApp": "Your trip appears in the IMT Oma Loma app after payment",
  "passengerInfo.fields.firstName": "First name (as in passport)",
  "passengerInfo.fields.lastName": "Last name (as in passport)",
  "passengerInfo.fields.gender": "Gender",
  "passengerInfo.fields.nationality": "Nationality",
  "passengerInfo.fields.dateOfBirth": "Date of birth (DD.MM.YYYY)",
  "passengerInfo.fields.dateOfBirthRequired": "Enter the date of birth.",
  "passengerInfo.fields.dateOfBirthInvalid": "Check the date of birth — use the format dd.mm.yyyy.",
  "passengerInfo.fields.dateOfBirthFuture": "The date of birth can't be after the trip's return day.",
  "passengerInfo.fields.dateOfBirthChildMismatch": "This date of birth gives an age of {actual} on the return day, but the trip is booked for a {expected}-year-old. Fix the date of birth, or change the child's age in the trip details.",
  "passengerInfo.fields.dateOfBirthAdult": "This date of birth gives an age of {actual} on the return day. A passenger must be at least {min} — add anyone younger as a child in the trip details.",
  "passengerInfo.age.atReturn": "Age on the return day: {age} years",
  "passengerInfo.fields.phone": "Phone number (optional)",
  "passengerInfo.fields.phoneRequired": "Phone number",
  "passengerInfo.fields.phoneAccountLocked": "This is your account's sign-in number, so it can't be changed on a booking.",
  "passengerInfo.fields.clubOne": "Club One number (optional)",
  "passengerInfo.fields.email": "Email (optional)",
  "passengerInfo.fields.emailRequired": "Email",
  "passengerInfo.fields.street": "Street address",
  "passengerInfo.fields.zip": "Postal code",
  "passengerInfo.fields.city": "City",
  "passengerInfo.fields.ownCarPlate": "Car license plate",
  "passengerInfo.fields.companyName": "Company name",
  "passengerInfo.fields.businessId": "Business ID",
  "passengerInfo.fields.businessIdInvalid": "Check the business ID (e.g. 1234567-1)",
  "passengerInfo.company.toggle": "Invoice to a company",
  "passengerInfo.busStops.title": "Domestic transport",
  "passengerInfo.busStops.origin": "Departure city",
  "passengerInfo.busStops.return": "Return city",
  "passengerInfo.busStops.originStop": "Pickup stop",
  "passengerInfo.busStops.returnStop": "Drop-off stop",
  "passengerInfo.busStops.stop": "Bus stop",
  "passengerInfo.busStops.separateReturn": "I want different stops out and back",
  "passengerInfo.busStops.sameReturn": "Same stop both ways",
  "passengerInfo.busStops.outboundHeading": "Outbound",
  "passengerInfo.busStops.returnHeading": "Return",
  "passengerInfo.busStops.returnNote": "On the way back you get off at: {stop}",
  "passengerInfo.busStops.noMatchingReturn": "The return coach doesn’t stop at your pickup stop, so choose the drop-off stop separately.",
  "passengerInfo.busStops.changeReturn": "Change",
  "passengerInfo.busStops.changeReturnAria": "Choose a different stop for the way back",
  "passengerInfo.busStops.change": "Change",
  "passengerInfo.busStops.changeAria": "Change the city the transport leaves from or returns to",
  "passengerInfo.busStops.saveError": "Saving the change failed. Please try again.",
  "passengerInfo.busStops.noTransport": "No transport",
  "passengerInfo.busStops.citiesLoading": "Loading cities…",
  "passengerInfo.busStops.citiesError": "Loading the cities failed. Please try again.",
  "passengerInfo.busStops.cancel": "Cancel",
  "passengerInfo.busStops.saving": "Saving…",
  "passengerInfo.busStops.applyAll.title": "Same stop for everyone?",
  "passengerInfo.busStops.applyAll.bodyEveryone": "Would you like to choose the same stop, “{stop}”, for all passengers on both the outbound and return journey?",
  "passengerInfo.busStops.applyAll.bodyBothWays": "Would you like to choose the same stop, “{stop}”, for both the outbound and return journey?",
  "passengerInfo.busStops.applyAll.yes": "Yes, for everyone",
  "passengerInfo.busStops.applyAll.no": "No thanks",
  "passengerInfo.ownCar.title": "Your car on board",
  "passengerInfo.gender.male": "Male",
  "passengerInfo.gender.female": "Female",
  "passengerInfo.optIn.promotional": "Yes please, send me travel news, offers and tips by email.",
  "passengerInfo.optIn.newsletterDiscount": "Subscribe to the newsletter and get €1 off your booking.",
  "passengerInfo.optIn.itinerary": "Send the trip details to everyone by email",
  "passengerInfo.special.title": "Special requests and other notes",
  "passengerInfo.special.help": "You can write any wishes related to your trip and other notes in the field below. An imt.fi representative will read your message and pass it on to the providers involved in the trip. We cannot, however, guarantee that all requests will be fulfilled.",
  "passengerInfo.special.label": "Special requests and other notes",
  "privacyNote.text": "Your details are handled securely, in line with the imt.fi {privacy}.",
  "privacyNote.link": "privacy statement",
  "passengerInfo.invoiceRows.title": "Per-passenger discounts and surcharges",
  "passengerInfo.invoiceRows.help": "The rows show on the customer's price breakdown with their description and count towards the total. A row is saved once it has an amount and a description.",
  "passengerInfo.invoiceRows.passenger": "Passenger {index}",
  "passengerInfo.invoiceRows.add": "Add invoice row",
  "passengerInfo.invoiceRows.addition": "Surcharge",
  "passengerInfo.invoiceRows.subtraction": "Discount",
  "passengerInfo.invoiceRows.amount": "Amount €",
  "passengerInfo.invoiceRows.description": "Description",
  "passengerInfo.invoiceRows.remove": "Remove invoice row",
  "passengerInfo.invoiceRows.saving": "Saving…",
  "passengerInfo.invoiceRows.incomplete": "Fill in the amount and the description to save the row.",
  "passengerInfo.invoiceRows.saveFailed": "Saving the invoice row failed. Please try again.",
  "passengerInfo.travelStepNotes.title": "Notes for the hotel/service",
  "passengerInfo.travelStepNotes.help": "Sent to the hotel or service with the passenger list. One note per hotel or service; write it in a language the recipient reads.",
  "passengerInfo.travelStepNotes.target": "Hotel or service",
  "passengerInfo.travelStepNotes.content": "Note",
  "passengerInfo.travelStepNotes.add": "Add",
  "passengerInfo.travelStepNotes.edit": "Edit",
  "passengerInfo.travelStepNotes.remove": "Remove",
  "passengerInfo.travelStepNotes.save": "Save",
  "passengerInfo.travelStepNotes.cancel": "Cancel",
  "passengerInfo.travelStepNotes.sunhotels": "Note: a Sunhotels hotel — write the note in the Sunhotels agent portal.",
  "passengerInfo.travelStepNotes.noSteps": "The reservation has no hotel or service to send a note to.",
  "passengerInfo.travelStepNotes.loadFailed": "Loading the notes failed.",
  "passengerInfo.travelStepNotes.saveFailed": "Saving the note failed. Please try again.",
  "passengerInfo.cta.continue": "Continue to summary",
  "passengerInfo.cta.continueShort": "Continue",
  "passengerInfo.state.loading": "Loading reservation…",
  "passengerInfo.state.error": "Failed to load reservation.",
  "passengerInfo.state.noActiveReservation": "You have no active reservation.",
  "payment.state.noActiveReservation": "You have no active reservation.",
  "passengerInfo.cta.saving": "Saving…",
  "passengerInfo.cta.missingHintGeneric": "Fill in all required fields to continue.",
  "passengerInfo.cta.missingOnePerson": "One more person’s details to fill in",
  "passengerInfo.cta.missingPeople": "{count} more people’s details to fill in",
  "passengerInfo.skipMissing.toggle": "Allow missing details",
  "passengerInfo.skipMissing.note": "Empty fields are saved blank and can be filled in later in the ERP. The booker's phone number is still required, and filled-in fields must still be valid.",
  "passengerInfo.skipMissing.gdsFlightWarning": "A GDS flight needs every passenger's name, gender and date of birth. If you continue without them, choose “Skip GDS flight booking” on the payment step.",
  "passengerInfo.skipMissing.listTitle": "Left unfilled",
  "passengerInfo.skipMissing.continue": "Continue with missing details",
  "passengerInfo.skipMissing.hint": "Some details will be left unfilled.",
  "passengerInfo.save.error": "Saving the details failed. Please try again.",
  "passengerInfo.personSearch.open": "Find customer details",
  "passengerInfo.personSearch.title": "Find customer details",
  "passengerInfo.personSearch.lead": "Search for an existing customer by name, date of birth or reservation number and attach their details to this reservation.",
  "passengerInfo.personSearch.close": "Close search",
  "passengerInfo.personSearch.name": "Name",
  "passengerInfo.personSearch.dateOfBirth": "Date of birth (DD.MM.YYYY)",
  "passengerInfo.personSearch.reservationId": "Reservation no.",
  "passengerInfo.personSearch.hint": "Type at least two letters of a name, a date of birth as dd.mm.yyyy, or a reservation number.",
  "passengerInfo.personSearch.loading": "Searching customers…",
  "passengerInfo.personSearch.error": "The customer search failed. Please try again.",
  "passengerInfo.personSearch.noResults": "No matches. Try different search terms.",
  "passengerInfo.personSearch.noName": "Unnamed customer",
  "passengerInfo.personSearch.alreadyInUse": "In use",
  "passengerInfo.personSearch.customerAccount": "Customer account",
  "passengerInfo.personSearch.shared": "On other reservations",
  "passengerInfo.personSearch.linkError": "Attaching the customer failed. Please try again.",
  "passengerInfo.personSearch.linkConflict": "This customer is already a passenger on this reservation.",
  "passengerInfo.personSearch.detach": "Detach customer from this reservation",
  "passengerInfo.personSearch.editInErp": "Edit customer details in the ERP",
  "passengerInfo.personSearch.lockedNotice": "This customer is on other reservations too, so their details are edited in the ERP — changes made here will not update them.",
  "login.dialog.title": "Sign in to your account",
  "login.dialog.perksLead": "Once you sign in, your trip appears in the IMT Oma Loma app.",
  "login.dialog.perkBonus": "Earn holiday bonus",
  "login.dialog.perkApp": "All your details in one place",
  "login.dialog.perkChat": "Chat customer service",
  "login.dialog.phoneLead": "Start by requesting a sign-in code",
  "login.dialog.phoneLabel": "Your phone number",
  "login.dialog.phonePlaceholder": "e.g. 040 123 4567",
  "login.dialog.phoneError": "Check the phone number, e.g. 040 123 4567.",
  "login.dialog.phoneHint": "We'll text you a sign-in code free of charge. Please use the same number you created your customer account with.",
  "login.dialog.noAccount": "I don't have an account, I'd like to create one",
  "login.dialog.haveAccount": "I already have an account, let me sign in",
  "login.dialog.joinTitle": "Join for free",
  "login.dialog.joinPerksLead": "Once you join, your trip appears in the IMT Oma Loma app.",
  "login.dialog.joinPhoneLead": "Start with your phone number",
  "login.dialog.joinContinue": "Continue",
  "login.dialog.joinPhoneHint": "We need your number to create the account. We'll confirm it with a free text message once you've filled in your details.",
  "login.dialog.registerTitle": "Join the loyalty programme",
  "login.dialog.registerLead": "We'll create an account for {phone}. Just these details to go.",
  "login.dialog.firstName": "First name",
  "login.dialog.lastName": "Last name",
  "login.dialog.email": "Email",
  "login.dialog.city": "Home town",
  "login.dialog.privacyPrefix": "I accept the",
  "login.dialog.privacyPolicyLink": "privacy statement",
  "login.dialog.privacyAnd": "and the",
  "login.dialog.privacyTermsLink": "loyalty programme terms",
  "login.dialog.newsletter": "Send me the email newsletter. I can unsubscribe at any time from the link in the newsletter.",
  "login.dialog.registerIncomplete": "Fill in every field and accept the terms.",
  "login.dialog.registerSubmit": "Create an account",
  "login.dialog.registerBack": "Edit the details",
  "login.dialog.creating": "Creating your account…",
  "login.dialog.registerFailed": "Couldn't create the account. Please try again in a moment.",
  "login.dialog.registerPhoneInUse": "This number already has a customer account. Sign in instead.",
  "login.dialog.requestCode": "Request a sign-in code",
  "login.dialog.sending": "Sending sign-in code…",
  "login.dialog.codeTitle": "Enter the sign-in code",
  "login.dialog.codeHelp": "The 6-digit code you received expires in 10 minutes.",
  "login.dialog.codeLabel": "Sign-in code",
  "login.dialog.signIn": "Sign in",
  "login.dialog.tryAgain": "Try again",
  "login.dialog.tryAnotherNumber": "Try another number",
  "login.dialog.verifying": "Verifying the code…",
  "login.dialog.invalidCode": "That code is not valid. Please check and try again.",
  "login.dialog.requestFailed": "Couldn't send the sign-in code. Please try again in a moment.",
  "login.dialog.accountMissingTitle": "No customer account found",
  "login.dialog.accountMissingHelp": "There is no customer account for the number you entered. You can try another number, or continue your booking without signing in.",
  "login.dialog.close": "Close",
  "login.dialog.successTitle": "Signed in",
  "login.dialog.successHelp": "Welcome! We'll prefill the booker details from your account. You can edit them if needed.",
  "login.dialog.successReplacedHelp": "We brought in the booker details from your account. Check they're up to date before you continue.",
  "login.dialog.reviewDetails": "Review details",
  "login.dialog.continue": "Continue",
  "login.dialog.existingAccountTitle": "You already have an account",
  "login.dialog.existingAccountHelp": "There's already a customer account for this phone number. Sign in to use your loyalty benefits. We'll bring in the booker details from your account, and you can check they're up to date. You can also continue booking without signing in.",
  "bookingSummary.appbar.back": "Back",
  "bookingSummary.appbar.title": "Summary",
  "bookingSummary.trip.title": "Your trip includes",
  "bookingSummary.trip.productFallback": "Selected trip item",
  "bookingSummary.trip.baggage": "Baggage included in the ticket",
  "bookingSummary.trip.bus": "Coach",
  "bookingSummary.trip.included": "Included in your trip",
  "bookingSummary.trip.rooms": "{count} × {room}",
  "journeyTimes.arrivesOn": "Arrives {date}",
  "journeyTimes.via": "via {airports}",
  "bookingSummary.extras.title": "Add-ons",
  "bookingSummary.extras.cancellation": "Cancellation cover · {label}",
  "bookingSummary.extras.free": "Included",
  "bookingSummary.passengers.title": "Travellers",
  "bookingSummary.passengers.fallback": "Passenger {index}",
  "bookingSummary.passengers.adult": "adult",
  "bookingSummary.passengers.child": "child",
  "bookingSummary.passengers.contactTitle": "Contact details",
  "bookingSummary.passengers.itineraryNoteOne": "The trip confirmation will be sent to this email",
  "bookingSummary.passengers.itineraryNote": "The trip confirmation will be sent to these emails",
  "bookingSummary.cta": "Continue to payment",
  "bookingSummary.ctaShort": "Payment",
  "cancellationPolicy.checkDetails.title": "Please check that the travel dates and passenger details are correct",
  "cancellationPolicy.checkDetails.body": "We pass passenger details on to the airlines immediately; for changes made after booking we have to charge, on top of our service fee, the actual costs we incur, which for flights may be their full price.",
  "cancellationPolicy.safeTravel.more": "More information",
  "cancellationPolicy.safeTravel.less": "Show less",
  "cancellationPolicy.safeTravel.body": "If, at the time of travel, the Finnish authorities* advise against travelling abroad or to your chosen destination, we refund the price you paid in full. We promise to return your payment within five business days of the cancellation.",
  "cancellationPolicy.safeTravel.footnote": "*Of the authorities, it is the Ministry for Foreign Affairs that issues travel advice through its travel advisories.",
  "cancellationPolicy.riskFree.title": "Risk-free booking – you can make changes or cancel the trip free of charge until 23:00 today!",
  "cancellationPolicy.riskFree.body": "Please still check that the travel dates and passenger details are definitely correct. We start passing passenger details on to the airlines at 23:00 today; after that, for changes we have to charge, on top of our service fee, the actual costs we incur, which for flights may be their full price.",
  "tripConditions.euRights": "The combination of travel services offered to you is a package within the meaning of Directive (EU) 2015/2302. Therefore, you will benefit from all EU rights applying to packages. Ikaalisten Matkatoimisto will be fully responsible for the proper performance of the package as a whole. Additionally, as required by law, Ikaalisten Matkatoimisto has protection in place to refund your payments and, where transport is included in the package, to ensure your repatriation in the event that it becomes insolvent. More information on {travellerRights} under Directive (EU) 2015/2302.",
  "tripConditions.euRights.travellerRights": "key rights",
  "tripConditions.eyebrow": "Package travel protection",
  "tripConditions.headline": "One booking – we're responsible for your whole trip",
  "tripConditions.benefit.organiser": "{list} from one responsible organiser",
  "tripConditions.benefit.protected": "Your payment is protected and your return journey secured",
  "tripConditions.benefit.refund": "Full refund if authorities advise against travel",
  "tripConditions.links.travellerRights": "Your key rights",
  "tripConditions.links.packageTerms": "General package travel terms",
  "tripConditions.links.specialTerms": "Additional and special terms",
  "tripConditions.teaser": "{list} in one booking. We're responsible for your whole trip.",
  "tripConditions.sidebar": "{list} in one booking",
  "tripConditions.cta": "Package travel protection",
  "tripConditions.contents.bus": "buses",
  "tripConditions.contents.busOne": "bus",
  "tripConditions.contents.flight": "flights",
  "tripConditions.contents.flightOne": "flight",
  "tripConditions.contents.ship": "ferries",
  "tripConditions.contents.shipOne": "ferry",
  "tripConditions.contents.hotel": "hotels",
  "tripConditions.contents.hotelOne": "hotel",
  "tripConditions.contents.and": "and",
  "tripConditions.contents.fallback": "your whole trip",
  "bookingSummary.state.loading": "Loading summary…",
  "bookingSummary.state.error": "Failed to load summary.",
  "bookingSummary.state.noActiveReservation": "You have no active reservation.",
  "payment.appbar.back": "Back",
  "payment.appbar.title": "Pay",
  "payment.method.title": "Choose payment method",
  "payment.method.loading": "Loading payment methods…",
  "payment.method.error": "Failed to load payment methods. Try again from the Summary page.",
  "payment.method.alreadyPaid": "This reservation has already been paid, so there is nothing left to pay.",
  "payment.method.alreadyConfirmed": "This reservation has already been confirmed. You can view the confirmation below.",
  "payment.method.viewConfirmation": "View confirmation",
  "payment.method.empty": "No payment methods are currently available.",
  "payment.method.priceIncreased": "The trip price changed while finalising your booking. Check the total and continue at the new price.",
  "payment.method.priceIncreasedRetry": "Continue at the new price",
  "payment.method.priceDecreasedTitle": "Price went down",
  "payment.method.priceDecreasedBody": "The trip price dropped from €{from} to €{to} while finalising your booking. You'll pay the updated, lower price.",
  "payment.method.priceChangedTitle": "The amount to pay changed",
  "payment.method.priceChangedBody": "The amount to pay changed from €{from} to €{to}. Check the total before you continue.",
  "payment.method.discountCodeDroppedTitle": "Discount code no longer applies",
  "payment.method.discountCodeDroppedBody": "The discount code {code} could no longer be applied to this booking and was removed. Check the total before you continue.",
  "payment.method.providerUnavailable": "The payment method you chose isn't available for this payment. Please choose another one.",
  "payment.method.flightUnavailable": "Your selected flight is no longer available. Go back to pick a new flight.",
  "payment.method.hotelUnavailable": "Your selected hotel is no longer available. Go back to pick a new hotel.",
  "payment.method.rePick": "Back to selection",
  "payment.skipGds.lead": "Alternatively, you can skip the GDS booking and invoice the reservation manually.",
  "payment.skipGds.flight": "Skip GDS flight booking.",
  "payment.skipGds.hotel": "Skip hotel booking.",
  "payment.skipGds.invoiceManually": "Skip GDS and invoice manually",
  "payment.method.processing": "Processing…",
  "payment.providerGroup.mobile": "Mobile payment",
  "payment.providerGroup.bank": "Bank payment",
  "payment.providerGroup.creditcard": "Card payment",
  "payment.providerGroup.credit": "Invoice & instalment",
  "payment.cta.pickProviderHint": "Pick a payment method to continue.",
  "payment.cta.readyHint": "You'll be taken to the payment service you chose.",
  "payment.cta.pay": "Pay",
  "payment.cta.payAmount": "Pay {amount} €",
  "payment.covered.lead": "The gift card covers the full total. Confirm your booking below and we'll finalise it without a separate payment.",
  "payment.covered.rewardTripLead": "The reward trip covers the full total. Confirm your booking below and we'll finalise it without a separate payment.",
  "payment.covered.confirm": "Confirm booking",
  "payment.covered.hint": "Gift card covers the total.",
  "payment.covered.rewardTripHint": "Reward trip covers the total.",
  "payment.prepay.title": "How much do you pay now?",
  "payment.prepay.fullName": "Full amount",
  "payment.prepay.splitName": "Pay later, no fees · {percentage} % now",
  "payment.prepay.fullSub": "No later payments",
  "payment.prepay.splitInvoice": "The invoice for the remainder is sent by email.",
  "payment.prepay.remainderDue": "Remaining {amount} € due by {date}",
  "payment.prepay.payNow": "Pay now",
  "payment.prepay.payLater": "Due later",
  "payment.side.tripTotal": "Trip total",
  "payment.side.bonusGain": "You earn holiday bonus +{amount} €",
  "payment.actionbar.now": "Now",
  "payment.actionbar.terms": "By paying you accept the terms",
  "payment.type.AllPaytrail": "Online payment (Paytrail)",
  "payment.type.PaytrailAndEmail": "Advance now + invoiced remainder",
  "payment.type.AllEmail": "Email invoice",
  "payment.type.AllSnailMail": "Postal invoice",
  "payment.type.PaymentLink": "Payment link by email",
  "payment.type.DontSend": "Don't send",
  "payment.type.missingEmail": "Email address missing",
  "payment.type.missingAddress": "Billing address missing",
  "payment.invoice.email": "The invoice is sent to the customer by email.",
  "payment.invoice.snailMail": "The invoice is sent to the customer by post.",
  "payment.invoice.dontSend": "No invoice is sent — the booking is confirmed without delivery.",
  "payment.invoice.missingFields": "The reserver's details aren't sufficient for this payment type. Complete them in the passenger details.",
  "payment.invoice.confirm": "Confirm booking and create invoice",
  "payment.invoice.dueDatesLoading": "Loading the due dates…",
  "payment.invoice.dueDatesFailed": "The due dates couldn't be loaded. They show on the invoice once it's created.",
  "payment.invoice.dueDate": "Due date",
  "payment.invoice.dueDateAdvance": "Advance payment due ({percentage}%)",
  "payment.invoice.dueDateRemainder": "Remainder due",
  "payment.invoice.priorPayments": "This reservation already has payments recorded. The new invoice is for the whole amount, earlier invoices are credited and the payments move onto the new invoice.",
  "payment.reinvoice.credit": "Credit note for invoice {id} (ref. {refNumber})",
  "payment.reinvoice.newInvoice": "New invoice",
  "payment.reinvoice.refundBonus": "Bonus used (refund bonus)",
  "payment.reinvoice.alreadyPaid": "Paid earlier",
  "payment.reinvoice.toPay": "Left to pay",
  "payment.reinvoice.overpaid": "Overpaid, to refund",
  "payment.reinvoice.paidUnavailable": "Could not load earlier payments",
  "payment.warning.gdsUsePaymentLink": "Note: this is a GDS booking, so use a payment link.",
  "payment.warning.gdsSnailMailDueToday": "The trip includes Sabre flights, so the invoice falls due today. A paper invoice may not arrive in time.",
  "payment.warning.snailMailLate": "Departure is 5 days away or less, so the invoice falls due today. A paper invoice may not arrive in time.",
  "payment.warning.paymentLinkInProgress": "The booking is In progress, so the customer can't use a payment link. Set it to Preliminary in the ERP. The booking isn't cancelled automatically while the link is valid.",
  "payment.paymentLink.lead": "The customer is emailed a payment link to pay for the booking. The booking is confirmed only after payment.",
  "payment.paymentLink.send": "Send payment link",
  "payment.paymentLink.sent": "Payment link sent to the customer by email. The booking is confirmed once the customer has paid.",
  "payment.terms.terms": "travel terms",
  "payment.terms.special": "additional and special terms",
  "payment.terms.consentPay": "By paying you accept the {terms} and the {special}.",
  "payment.terms.consentConfirm": "By confirming you accept the {terms} and the {special}.",
  "payment.trust.secure": "Payments processed by Paytrail",
  "payment.trust.legal": "Package travel protection",
  "payment.success.title": "Booking confirmed!",
  "payment.success.greeting": "Thank you! Great choice to book your trip with us.",
  "payment.success.bookingNumber": "Your booking number is {id}.",
  "payment.success.prepaid": "You paid the advance. We sent the invoice for the remainder to your email, where you can see the amount and the due date.",
  "payment.success.invoiceDue": "Invoice due",
  "payment.success.email": "We sent more details about your booking to your email. Sometimes the message ends up in spam.",
  "payment.success.staffEmail": "The trip confirmation is emailed to the customer if their email address is known.",
  "payment.success.staffInvoice.AllEmail": "The invoice is sent to the customer by email.",
  "payment.success.staffInvoice.AllSnailMail": "The invoice is sent to the customer by post.",
  "payment.success.staffInvoice.DontSend": "No invoice is sent to the customer.",
  "payment.success.app": "Download the IMT Oma Loma app next",
  "payment.success.appPerk.tripInfo": "All your trip details in one place",
  "payment.success.appPerk.chat": "Chat with customer service",
  "payment.success.appDownload": "You can download the app here:",
  "payment.success.appScan": "You can scan the QR code with your phone's camera to download the app.",
  "payment.success.appQrAlt": "QR code that opens the app download page app.imt.fi",
  "payment.success.appLogin": "Sign in to the app with the number {phone}.",
  "payment.success.close": "Back to home",
  "feedback.question": "On a scale of 1–5, how easy was it to make your booking?",
  "feedback.starLabel": "{value}/5",
  "feedback.improve": "Where could we improve? (Your feedback won't affect your booking – we just want to learn and improve our service!)",
  "feedback.idea": "What gave you the idea to book this particular trip with IMT?",
  "feedback.send": "Send feedback",
  "feedback.error": "Sending your feedback failed. Please try again.",
  "feedback.privacy": "Our {privacy} explains how we handle your feedback.",
  "feedback.privacyLink": "privacy statement",
  "feedback.thanks.title": "Thank you for your feedback!",
  "feedback.thanks.body": "We really appreciate you taking the time to help us improve our service. Every piece of feedback matters to us and helps us offer an even better experience to you and our other customers.",
  "giftCard.expand": "Have a gift card?",
  "giftCard.label": "Gift card code",
  "giftCard.placeholder": "e.g. 12345-ABC",
  "giftCard.submit": "Apply gift card",
  "giftCard.submitting": "Checking…",
  "giftCard.cancel": "Cancel",
  "giftCard.remove": "Remove",
  "giftCard.applied.title": "Gift card applied · {amount} €",
  "giftCard.applied.rewardTripTitle": "Reward trip applied · {amount} €",
  "giftCard.applied.remainingBalance": "Balance after payment {amount} €",
  "giftCard.applied.singleUseValue": "Reward trip value {amount} €, single use",
  "giftCard.error.notFound": "Gift card not found. Check the code.",
  "giftCard.error.empty": "Gift card has no balance left.",
  "giftCard.error.expired": "Gift card has expired.",
  "giftCard.error.wrongTrip": "This code isn't valid for this trip.",
  "giftCard.error.alreadyPaid": "Reservation is already paid; can't add a gift card.",
  "giftCard.error.unknown": "Could not apply gift card. Try again.",
  "discountCode.expand": "Add a discount code",
  "discountCode.label": "Discount code",
  "discountCode.placeholder": "e.g. SUMMER25",
  "discountCode.submit": "Apply code",
  "discountCode.submitting": "Checking…",
  "discountCode.cancel": "Cancel",
  "discountCode.remove": "Remove",
  "discountCode.applied.title": "Discount code {code} applied",
  "discountCode.applied.amount": "Discount −{amount} €",
  "discountCode.error.notFound": "Unknown discount code.",
  "discountCode.error.invalid": "Discount code is not valid.",
  "discountCode.error.campaignClosed": "This discount code's campaign is not running right now.",
  "discountCode.error.wrongDeparture": "This discount code does not cover your departure date.",
  "discountCode.error.requiresProduct": "This discount code requires your trip to include one of: {products}. Change your selection and try the code again.",
  "discountCode.error.alreadyApplied": "The reservation already has a discount code. Remove it first.",
  "discountCode.error.noPriceLeft": "There is no price left on the reservation to discount.",
  "discountCode.error.usableTimesDepleted": "Discount code has been used up.",
  "discountCode.error.unknown": "Could not apply discount code. Try again.",
  "discountCode.dropped": "Discount code {code} was removed because it no longer applies to your changed trip.",
  "discountCode.dropped.dismiss": "Got it",
  "passengerInfo.tripName.dialog.title": "Rename your trip",
  "passengerInfo.tripName.dialog.body": "You can rename the trip to something that suits your group better. Renaming it doesn't change what the trip includes.",
  "passengerInfo.tripName.dialog.hint": "For example \"The Smith family Christmas trip\".",
  "passengerInfo.tripName.dialog.label": "Trip name",
  "passengerInfo.tripName.dialog.reset": "Restore the original name",
  "passengerInfo.tripName.dialog.done": "Done",
  "passengerInfo.tripName.dialog.close": "Close",
  "editor.basicsReset.title": "Change your trip details?",
  "editor.basicsReset.body": "Changing the dates or the number of travellers re-searches the hotel, ferries and add-on services and resets your choices back to the defaults.",
  "editor.basicsReset.confirm": "Change and reset choices",
  "editor.basicsReset.cancel": "Keep current",
  "editor.partyCarryOver.title": "Not everything could be kept",
  "editor.partyCarryOver.body": "The change of travellers kept every choice the trip still had room for. These changed:",
  "editor.partyCarryOver.classChanged": "Same departure, another class",
  "editor.partyCarryOver.departureChanged": "Another departure",
  "editor.partyCarryOver.lost": "No longer available",
  "editor.partyCarryOver.nothing": "nothing",
  "editor.partyCarryOver.extraDropped": "{name}: dropped",
  "editor.partyCarryOver.extraNotForNew": "{name}: not added for the new travellers",
  "editor.partyCarryOver.frozenPricesLost": "Frozen prices lost: {count}",
  "editor.partyCarryOver.total": "Price: {before} € → {after} €",
  "editor.partyCarryOver.ok": "OK",
  "editor.transportReset.title": "Change how you travel?",
  "editor.transportReset.body": "This change re-searches your ferries and cabins, and may remove add-on services and tickets you have booked.",
  "editor.transportReset.confirm": "Change and reset choices",
  "editor.transportReset.cancel": "Keep current",
  "startOver.crossTrip.title": "You already have a booking in progress",
  "startOver.crossTrip.body": "You can carry on with the booking you started, or begin a new one for the trip you just opened. Starting a new booking cancels the unfinished one.",
  "startOver.sameTrip.title": "Continue your booking?",
  "startOver.sameTrip.body": "You already have an unfinished booking for this trip. You can pick up where you left off, or start over. Starting over cancels the unfinished booking.",
  "startOver.existingLabel": "Your unfinished booking",
  "startOver.requestedLabel": "The trip you just opened",
  "startOver.reservationNumber": "Booking number {id}",
  "startOver.tripFallback": "Your trip",
  "startOver.requestedTripFallback": "The trip you chose",
  "startOver.resume": "Continue booking",
  "startOver.replace": "Start a new booking",
  "startOver.replaceSameTrip": "Start over",
  "ferrySheet.outbound.title": "Choose your outbound ferry",
  "ferrySheet.inbound.title": "Choose your return ferry",
  "ferrySheet.cruise.title": "Choose your cruise",
  "ferrySheet.outbound.empty": "No outbound departures available.",
  "ferrySheet.inbound.empty": "No return departures available.",
  "ferrySheet.cruise.empty": "No cruise departures available.",
  "ferrySheet.close": "Close",
  "ferrySheet.count": "{count} departures",
  "ferrySheet.countOne": "1 departure",
  "ferrySheet.onlyOption": "There is only one ship for this trip — pick your places below.",
  "ferrySheet.select": "Select",
  "ferrySheet.selected": "Selected",
  "ferrySheet.price.included": "No extra charge",
  "ferrySheet.price.includedDiscount": "Includes {amount} € / person off",
  "ferrySheet.option.title": "{time} · {ship}",
  "ferrySheet.option.titleNoShip": "{time}",
  "ferrySheet.option.arrival": "Arrives {time}",
  "ferrySheet.option.duration": "Journey time {duration}",
  "ferrySheet.back": "Back",
  "ferrySheet.card.tag": "Deck place",
  "ferrySheet.card.discountShort": "Sale",
  "ferrySheet.busFilter.count": "{count} departures your coach connects to",
  "ferrySheet.busFilter.countOne": "1 departure your coach connects to",
  "ferrySheet.busFilter.showAll": "Show all ferries ({count})",
  "ferrySheet.busFilter.showConnecting": "Show only ferries your coach connects to",
  "ferrySheet.busFilter.notice": "Doesn't fit the schedule of your chosen coach transfer.",
  "ferrySheet.busFilter.noneTitle": "No departure fits the schedule of your coach transfer.",
  "ferrySheet.busFilter.noneBody": "Every departure is still listed. Choosing one of them means no coach transfer runs to it. You can also change how you get to the port, or pick different travel dates.",
  "ferrySheet.busFilter.changeTransport": "Change transport to the port",
  "ferrySheet.bus.toShip": "Coach to the ship",
  "ferrySheet.bus.fromShip": "Coach from the ship",
  "ferrySheet.bus.operator.imt": "Charter",
  "ferrySheet.bus.timetable": "Stop timetable",
  "ferrySheet.bus.timetableLoading": "Loading the stop timetable…",
  "ferrySheet.bus.timetableUnavailable": "The stop timetable couldn't be shown.",
  "ferrySheet.notices.title": "Please note",
  "ferrySheet.notices.showMore": "Show more",
  "ferrySheet.notices.showLess": "Show less",
  "timedNotice.untilFurtherNotice": "until further notice",
  "timedNotice.and": "and",
  "timedNotice.at": "at",
  "ferrySheet.price.perPerson": "+{amount} € / person",
  "ferrySheet.price.total": "+{amount} € in total",
  "ferrySheet.route": "{from} – {to} · {departure}–{arrival} · {duration}",
  "ferrySheet.routeTimes": "{departure}–{arrival} · {duration}",
  "ferrySheet.detail.showOnMap": "Show on map",
  "ferrySheet.detail.about": "About the ship",
  "ferrySheet.detail.services": "Onboard services",
  "ferrySheet.footer.total": "Package total",
  "ferrySheet.footer.confirm": "Confirm selections",
  "ferrySheet.footer.noPlace": "No place chosen",
  "ferrySheet.footer.placesChosen": "{chosen}/{total} places chosen",
  "ferrySheet.footer.allChosen": "{count} places chosen",
  "cancel.count": "{count} options",
  "cancel.countOne": "1 option",
  "cancel.select": "Select",
  "cancel.selected": "Selected",
  "editor.steps.upsells.count": "{count} add-on services",
  "editor.steps.upsells.countOne": "1 add-on service",
  "editor.steps.upsells.add": "Add",
  "editor.steps.upsells.added": "Added",
  "editor.steps.upsells.readMore": "Read more",
  "editor.steps.upsells.readLess": "Show less",
  "editor.steps.upsells.paxAll": "Added for all {count} passengers",
  "editor.steps.upsells.paxSome": "Added for {names}",
  "editor.steps.upsells.paxNone": "Choose passengers",
  "editor.steps.upsells.selectionTotal": "{price} € total",
  "editor.steps.upsells.remainingQuota": "Only {count} left – choose travellers below",
  "editor.steps.upsells.passengerSoldOut": "Sold out",
  "editor.steps.upsells.showMore": "Show more ({count})",
  "editor.steps.upsells.dateTime": "{date} at {time}",
  "editor.steps.upsells.chooseDay": "Choose a day",
  "editor.steps.upsells.fromPrice": "from {price}",
  "editor.steps.upsells.openingHours": "Opening hours",
  "editor.steps.upsells.closed": "Closed",
  "editor.steps.upsells.imageOpen": "Open the image larger: {name}",
  "cabinSheet.loading": "Loading cabins…",
  "cabinSheet.empty": "No cabins available.",
  "cabinSheet.setDeck": "Deck places · {people}",
  "cabinSheet.loadError": "Loading the cabins failed.",
  "cabinSheet.retry": "Try again",
  "cabinSheet.noneForSet": "No cabins are free for this group of travellers on this departure. Please choose another departure.",
  "cabinSheet.select": "Select",
  "cabinSheet.selected": "Selected",
  "cabinSheet.price.included": "No extra charge",
  "cabinSheet.fallbackName": "Cabin {index}",
  "cabinSheet.pickerTitle": "Choose a cabin or deck place",
  "cabinSheet.pickerTitleCabin": "Choose a cabin",
  "cabinSheet.pickerTitleCabins": "Choose cabins",
  "cabinSheet.pickerTitleDeck": "Choose a deck place",
  "cabinSheet.section": "Cabin {index} · {people}",
  "cabinSheet.count.cabinsOne": "1 cabin",
  "cabinSheet.count.cabins": "{count} cabins",
  "cabinSheet.count.deckPlacesOne": "1 deck place",
  "cabinSheet.count.deckPlaces": "{count} deck places",
  "cabinSheet.amenities": "Place facilities",
  "cabinSheet.scarcity": "Only {count} left!",
  "placeCard.staffQuota": "Quota left: {count}",
  "placeCard.staffUnavailablePrice": "Price: {price}",
  "placeCard.staffNoPrice": "No price: {products}",
  "placeCard.internalInfo": "Sales notes",
  "placeCard.showUnavailable": "Also show options that can't be booked",
  "placeCard.showUnavailableNote": "Sold-out and unpriced options are listed too. They can't be selected.",
  "cabinSheet.showMore": "Show more",
  "cabinSheet.showLess": "Show less",
  "cabinSheet.details": "More info",
  "cabinSheet.hideDetails": "Hide info",
  "cabinSheet.deal": "DEAL",
  "cabinSheet.price.perPerson": "+{amount} € / person",
  "cabinSheet.price.includedDiscount": "Includes {amount} € / person off",
  "cabinSheet.split.title": "Cabin split",
  "cabinSheet.split.edit": "Change cabin split",
  "cabinSheet.split.done": "Done",
  "cabinSheet.split.howMany": "How many cabins do you need?",
  "cabinSheet.split.allInOne": "Everyone in one cabin",
  "cabinSheet.split.cabins": "{count} cabins",
  "cabinSheet.split.cabin": "Cabin {index}",
  "cabinSheet.split.deck": "Deck places",
  "cabinSheet.split.moveTo": "Move to cabin {index}",
  "cabinSheet.split.moveToDeck": "Move to deck places",
  "cabinSheet.split.moveNew": "Move to a new cabin",
  "cabinSheet.split.cancel": "Cancel",
  "cabinSheet.split.note": "Changing the cabin split affects the package price. Choose a place type for each cabin below.",
  "cabinSheet.split.warnMax": "At most {count} people per cabin",
  "cabinSheet.split.warnChildAlone": "A child cannot travel in a cabin alone",
  "cabinSheet.split.warnEmpty": "A cabin must have at least one traveller",
  "cabinSheet.split.passenger": "Passenger {index}",
  "cabinSheet.split.child": "Child, age {age}",
  "cabinSheet.split.childNoAge": "Child",
  "cabinSheet.split.moveLabel": "Move {name}",
  "cabinSheet.split.summary": "{cabins} · {people}",
  "cabinSheet.split.groups.title": "Seating split",
  "cabinSheet.split.groups.edit": "Change split",
  "cabinSheet.split.groups.howMany": "How do you want to split the party?",
  "cabinSheet.split.groups.allInOne": "Everyone together",
  "cabinSheet.split.groups.count": "{count} groups",
  "cabinSheet.split.groups.moveNew": "Move to a new group",
  "cabinSheet.split.groups.note": "Changing the split affects the package price. Choose a cabin or deck places for each group below.",
  "pricing.adult": "Adult {index}",
  "pricing.adultOne": "Adult",
  "pricing.child": "Child {index}",
  "pricing.childOne": "Child",
  "pricing.childAge": "age {age}",
  "pricing.otherShare": "Other",
  "pricing.sharedLine": "split between travellers",
  "passengerInfo.tripName.rename": "Name your trip",
  "passengerInfo.tripName.error": "Couldn't save the trip name. The trip kept its previous name — please try again."
}
